import React from "react";
import LegalPageShell from "@/components/LegalPageShell";
import { useI18n } from "@/lib/i18n";

export default function ImpressumPage() {
  const { t } = useI18n();
  return <LegalPageShell {...t.legal.impressum} testId="page-impressum" />;
}
